import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "body2-text text-black" };
const _hoisted_2 = { class: "body2-text text-black" };
const _hoisted_3 = { class: "body2-text text-black" };
const _hoisted_4 = { class: "body2-text text-black" };
const _hoisted_5 = { class: "body2-text text-black" };
const _hoisted_6 = { class: "body2-text text-black" };
const _hoisted_7 = { class: "body2-text text-black" };
const _hoisted_8 = { class: "body2-text text-black" };
const _hoisted_9 = { class: "body2-text text-black" };
const _hoisted_10 = { class: "body2-text text-black" };
const _hoisted_11 = { class: "body2-text text-black mr-1" };
const _hoisted_12 = { class: "body2-text text-black" };
const _hoisted_13 = { class: "body2-text text-black" };
const _hoisted_14 = { class: "body2-text text-black" };
const _hoisted_15 = { class: "body2-text text-black" };
const _hoisted_16 = { class: "body2-text text-black" };
const _hoisted_17 = { class: "body2-text text-black" };
const _hoisted_18 = { class: "body2-text text-black" };
const _hoisted_19 = { class: "body2-text text-black" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_InputRow = _resolveComponent("InputRow");
    return (_openBlock(), _createElementBlock("div", null, [
        _createVNode(_component_InputRow, {
            label: _ctx.$t(`${_ctx.hubListLc}name`),
            "wide-title": ""
        }, {
            default: _withCtx(() => [
                _createElementVNode("span", _hoisted_1, _toDisplayString(_ctx.hubNameWithSlashDivider), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
        }, 8 /* PROPS */, ["label"]),
        _createVNode(_component_InputRow, {
            label: _ctx.$t(`${_ctx.hubDetailLc}distributor_name`),
            "wide-title": ""
        }, {
            default: _withCtx(() => [
                _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.distributorIdWithSlashDivider), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
        }, 8 /* PROPS */, ["label"]),
        _createVNode(_component_InputRow, {
            label: _ctx.$t(`${_ctx.hubDetailLc}master_id`),
            "wide-title": ""
        }, {
            default: _withCtx(() => [
                _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.validatedMasterId), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
        }, 8 /* PROPS */, ["label"]),
        _createVNode(_component_InputRow, {
            label: _ctx.$t(`${_ctx.hubListLc}address`),
            "wide-title": ""
        }, {
            default: _withCtx(() => [
                _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.formattedFullAddress), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
        }, 8 /* PROPS */, ["label"]),
        _createVNode(_component_InputRow, {
            label: _ctx.$t(`${_ctx.hubListLc}hub_representative_phone`),
            "wide-title": ""
        }, {
            default: _withCtx(() => [
                _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.formattedHubRepresentativePhone), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
        }, 8 /* PROPS */, ["label"]),
        _createVNode(_component_InputRow, {
            label: _ctx.$t(`${_ctx.hubListLc}store_exposure_phone`),
            "wide-title": ""
        }, {
            default: _withCtx(() => [
                _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.formattedHubPhone), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
        }, 8 /* PROPS */, ["label"]),
        _createVNode(_component_InputRow, {
            label: _ctx.$t(`${_ctx.hubListLc}fax`),
            "wide-title": ""
        }, {
            default: _withCtx(() => [
                _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.formattedFax), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
        }, 8 /* PROPS */, ["label"]),
        _createVNode(_component_InputRow, {
            label: _ctx.$t(`${_ctx.hubListLc}use_yn`),
            "wide-title": ""
        }, {
            default: _withCtx(() => [
                _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.validatedUseYn), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
        }, 8 /* PROPS */, ["label"]),
        _createVNode(_component_InputRow, {
            label: _ctx.$t(`${_ctx.hubListLc}working_time`),
            "wide-title": ""
        }, {
            default: _withCtx(() => [
                _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.formattedWorkingTime), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
        }, 8 /* PROPS */, ["label"]),
        _createVNode(_component_InputRow, {
            label: _ctx.$t(`${_ctx.hubListLc}deposit_baromoney`),
            "wide-title": ""
        }, {
            default: _withCtx(() => [
                _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.formattedDepositBaromoney), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
        }, 8 /* PROPS */, ["label"]),
        _createVNode(_component_InputRow, {
            label: _ctx.$t(`${_ctx.hubDetailLc}withdrawal_bank`),
            "wide-title": ""
        }, {
            default: _withCtx(() => [
                _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.withdrawBankWithSlashDivider), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
        }, 8 /* PROPS */, ["label"]),
        _createVNode(_component_InputRow, {
            label: _ctx.$t(`${_ctx.hubDetailLc}virtual_bank`),
            "wide-title": ""
        }, {
            default: _withCtx(() => [
                _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.virtualBankWithCommaDivider), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
        }, 8 /* PROPS */, ["label"]),
        _createVNode(_component_InputRow, {
            label: _ctx.$t(`${_ctx.hubListLc}business_number`),
            "wide-title": ""
        }, {
            default: _withCtx(() => [
                _createCommentVNode(" TODO p2에서 진행 예정\n        <Chip\n        :text=\"businessNumberComputed.text\"\n        :color=\"businessNumberComputed.color\"\n        :text-color=\"businessNumberComputed.textColor\"\n      >\n      </Chip> "),
                _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.validatedBusinessNumber), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
        }, 8 /* PROPS */, ["label"]),
        _createVNode(_component_InputRow, {
            label: _ctx.$t(`${_ctx.hubListLc}business_name`),
            "wide-title": ""
        }, {
            default: _withCtx(() => [
                _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.validatedBusinessName), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
        }, 8 /* PROPS */, ["label"]),
        _createVNode(_component_InputRow, {
            label: _ctx.$t(`${_ctx.hubListLc}ceo_name`),
            "wide-title": ""
        }, {
            default: _withCtx(() => [
                _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.validatedCeoName), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
        }, 8 /* PROPS */, ["label"]),
        _createVNode(_component_InputRow, {
            label: _ctx.$t(`${_ctx.hubListLc}ceo_phone`),
            "wide-title": ""
        }, {
            default: _withCtx(() => [
                _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.formattedCeoPhone), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
        }, 8 /* PROPS */, ["label"]),
        _createVNode(_component_InputRow, {
            label: _ctx.$t(`${_ctx.hubListLc}ceo_email`),
            "wide-title": ""
        }, {
            default: _withCtx(() => [
                _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.validatedCeoEmail), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
        }, 8 /* PROPS */, ["label"]),
        _createVNode(_component_InputRow, {
            label: _ctx.$t(`${_ctx.hubListLc}business_condition`),
            "wide-title": ""
        }, {
            default: _withCtx(() => [
                _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.validatedBusinessCondition), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
        }, 8 /* PROPS */, ["label"]),
        _createVNode(_component_InputRow, {
            label: _ctx.$t(`${_ctx.hubListLc}business_type`),
            "wide-title": ""
        }, {
            default: _withCtx(() => [
                _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.validatedBusinessType), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
        }, 8 /* PROPS */, ["label"])
    ]));
}
